module.exports = __webpack_public_path__ + "img/background-CTA.77ab7dc9.png";